export default __webpack_public_path__ + "static/media/iconeCidada.26ae350a.svg";